var
    _            = require('lodash'),
    gsap         = require('gsap'),
    $       = require('jquery');


function Cookies(options) {

    this.acceptanceCookiesName = 'cookie_policy_accepted';

    this.hookAcceptId = 'accept-cookie';

    this.lang = document.getElementsByTagName('html')[0].getAttribute('lang');

    this.utils = {

        set: function (cname, cvalue, exdays) {

            var d = new Date(),
                expires;

            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = 'expires=' + d.toUTCString();

            document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';

        },

        get: function (cname) {
            var name = cname + '=',
                ca,
                i,
                c;

            ca = document.cookie.split(';');

            for (i = 0; i < ca.length; i++) {
                c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }

            return '';
        }
    };

    this.cookieMessage = {

        html: _.template([

            '<div class="cookie-bar">',

            '<div class="cookie-bar__content">',

            '<p class="cookie-bar__text">',
            '<%= cookieText %> <%= cookieLink %>',
            '</p>',

            '<div class="cookie-bar__accept-outer">',

            '<button id="<%= cookieIdHook %>" class="Form__Submit">',
            '<%= cookieLabelAccept %>',
            '</button>',

            '</div>',

            '</div>',

            '</div>'

        ].join("\n"))

    };

    this.checkAccepted();
};

Cookies.prototype.checkAccepted = function () {

    var _this = this,
        hasAcceptedCookies;

    hasAcceptedCookies = _this.utils.get(_this.acceptanceCookiesName) !== '';

    if (!hasAcceptedCookies) {

        _this.showCookieBar();

        $(document).on('click', '#' + _this.hookAcceptId, function(e) {

            e.preventDefault();

            _this.accept();

        });
    }
};

Cookies.prototype.removeCookieBar = function () {

    var _this = this;

    if (!_this.$cookieBar.length) return false;

    gsap.to(
        _this.$cookieBar,
        .3,
        {
            yPercent: 100,
            onComplete: function() {

                // remove the message from the DOM
                _this.$cookieBar.remove();
                _this.$cookieBar = null;
            }
        }
    );

};

Cookies.prototype.showCookieBar = function () {

    var _this = this,
        html,
        _cookieText = 'We use cookies to ensure you get the best experience on our website. By using this website, you accept ',
        _cookieLink = '<a href="javascript:;" class="privacy-bt">terms and conditions in full</a>',
        _cookieAcceptLabel = 'Accept';

    if (_this.lang == 'it') {
        _cookieText = 'Utilizziamo i cookie per assicurarti la migliore esperienza possibile sul nostro sito. Navigandolo accetti ',
            _cookieLink = '<a href="javascript:;" class="privacy-bt">termini e condizioni</a>',
            _cookieAcceptLabel = 'Accetta';
    }

    // html = _this.cookieMessage.html({
    //     cookieText: global.labelHandler.getLabel('cookieText'),
    //     cookieLink: global.labelHandler.getLabel('cookieLink'),
    //     cookieIdHook: _this.hookAcceptId,
    //     cookieLabelAccept: global.labelHandler.getLabel('cookieAcceptLabel')
    // });

    html = _this.cookieMessage.html({
        cookieText: _cookieText,
        cookieLink: _cookieLink,
        cookieIdHook: _this.hookAcceptId,
        cookieLabelAccept: _cookieAcceptLabel
    });

    _this.$cookieBar = $(html);

    gsap.set(_this.$cookieBar, {
        yPercent: 100
    });

    $.when($('body').append(_this.$cookieBar)).done(function () {

        gsap.to(_this.$cookieBar, .5, {
            yPercent: 0,
            delay: 1,
            zIndex: 500
        });



    });
};

Cookies.prototype.accept = function () {

    var _this = this;

    _this.utils.set(_this.acceptanceCookiesName, 'accepted', 365);

    _this.removeCookieBar();

};

module.exports = new Cookies;


// WEBPACK FOOTER //
// ./js/components/cookies.js